export default {
  title: {
    generalConditions: 'Terms of use',
    legalMentions: 'Legal mentions',
    personalData: 'Personal data',
    privacyPolicy: 'Privacy policy'
  }

}
